import Vue from 'vue'
import Vuex from 'vuex'
import pathify from 'vuex-pathify'

import app from './modules/app'
import user from './modules/user'
import registration from './modules/registration'
import cleaning from './modules/cleaning'

Vue.use(Vuex)

export default new Vuex.Store({
  plugins: [pathify.plugin],

  modules: {
    app,
    user,
    registration,
    cleaning
  }
})
